(function () {

	//get localized data
	const sailthruData = window.hc_sailthru_data || {};
	const debug = sailthruData.debug || false;

	/**
	 * Check if logged-in user is already subscribed to CTA's list(s)
	 * If yes, hide the CTA. If no, show it.
	 */
	async function checkCTASubscription(form, container) {
		const listDataAttr = form.dataset.sailthruLists;
		if (!listDataAttr) {
			// No list data, show the form
			showCTAForm(container);
			return;
		}

		let ctaLists;
		try {
			ctaLists = JSON.parse(listDataAttr);
		} catch (e) {
			if (debug) console.error('SailThru: Failed to parse CTA lists', e);
			showCTAForm(container);
			return;
		}

		if (!Array.isArray(ctaLists) || ctaLists.length === 0) {
			showCTAForm(container);
			return;
		}

		if (debug) console.log('SailThru: CTA lists to check:', ctaLists);

		// Fetch user's current subscriptions
		try {
			const response = await fetch(sailthruData.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'om_get_email_preferences_data',
					security: sailthruData.nonce,
				}),
			});

			const data = await response.json();

			if (data.success && data.data) {
				if (debug) console.log('SailThru: User subscription data:', data.data);

				// Check if user is already subscribed to ALL lists in this CTA
				// ctaLists contains api_names like "CO Tenant Talk Newsletter"
				// data.data.all_lists contains { list_key: { api_name: "...", ... } }
				// data.data.preferences contains { list_key: true/false }
				
				const userPrefs = data.data.preferences || {};
				const allLists = data.data.all_lists || {};
				
				if (debug) {
					console.log('SailThru: All lists config:', allLists);
					console.log('SailThru: User subscriptions:', userPrefs);
				}

				// Check if user is already subscribed to ALL lists in this CTA
				const allSubscribed = ctaLists.every(ctaListName => {
					// ctaLists contains api_name values (e.g. "CO Tenant Talk Newsletter")
					// We need to find the list_key that has this api_name
					for (const [listKey, listDetails] of Object.entries(data.data.all_lists || {})) {
						if (listDetails.api_name === ctaListName) {
							// Check if user is subscribed using the list_key
							return data.data.preferences && data.data.preferences[listKey] === true;
						}
					}
					return false; // List not found in our config
				});

				if (allSubscribed) {
					if (debug) console.log('SailThru: User already subscribed to all CTA lists, hiding CTA');
					// Hide the CTA completely
					container.style.display = 'none';
					return;
				} else {
					if (debug) console.log('SailThru: User not subscribed to all CTA lists, showing CTA');
					showCTAForm(container);
				}
			} else {
				// Failed to fetch, show the form anyway
				if (debug) console.error('SailThru: Failed to fetch user preferences', data);
				showCTAForm(container);
			}
		} catch (error) {
			// Network error, show the form anyway
			if (debug) console.error('SailThru: Error fetching user preferences', error);
			showCTAForm(container);
		}
	}

	/**
	 * Show the CTA form by hiding loading state and showing wrapper
	 */
	function showCTAForm(container) {
		const loading = container.querySelector('[data-sailthru-loading]');
		const wrapper = container.querySelector('[data-sailthru-wrapper]');
		
		if (loading) loading.style.display = 'none';
		if (wrapper) wrapper.style.display = 'block';
		container.style.display = 'block';
		
		if (debug) console.log('SailThru: Showing CTA form');
	}

	/**
	 * Initialize the subscribe form based on context (require_login parameter)
	 */
	async function initSubscribeForm() {
		if (debug) console.log('SailThru:  Initializing subscribe form...');

		// Find the form
		const form = document.querySelector('[data-sailthru-form]');
		if (!form) {
			if (debug) console.log('SailThru: No form found on page.');
			return;
		}

		// Check the template context - does this form require login (account page) or not (public page)?
		const requireLogin = form.dataset.sailthruRequireLogin === 'true';
		
		// Check if user is actually logged in
		const isLoggedIn = sailthruData.is_logged_in || false;
		
		const container = form.closest('[data-sailthru-form-container]');
		
		// Check if this is a CTA (embedded signup) vs standalone page
		const isCTA = container && (
			container.classList.contains('hc-newsletters-cta') || 
			container.classList.contains('hc-fancy-newsletter-signup')
		);
		
		// Redirect logged-in users from standalone newsletter page to their account preferences
		// BUT NOT from CTAs (which are embedded in taxonomy/article pages)
		if (!requireLogin && isLoggedIn && !isCTA) {
			if (debug) console.log('SailThru: Logged-in user on standalone page, redirecting to account...');
			// Extract base path from current URL to support subdirectories (e.g., VIP staging)
			// Example: /nyocommercialobserver/newsletters/ -> /nyocommercialobserver/
			/*! phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment -- Safe: pathname is used only to construct internal redirect URL, not for DOM manipulation or output */
			const currentPath = window.location.pathname;
			const basePath = currentPath.substring(0, currentPath.lastIndexOf('/newsletters'));
			const redirectUrl = basePath + '/my-account/email-preferences';
			if (debug) console.log('SailThru: Redirecting to:', redirectUrl);
			window.location.assign(redirectUrl);
			return;
		}

		// For logged-in users on CTAs, check if they're already subscribed
		// If yes, hide the CTA. If no, continue to show it.
		if (isCTA && isLoggedIn) {
			// Show loading state while we check subscription
			container.style.display = 'block';
			await checkCTASubscription(form, container);
			// If the CTA was hidden by checkCTASubscription, don't continue initialization
			if (container.style.display === 'none') {
				return;
			}
		} else if (isCTA && !isLoggedIn) {
			// For logged-out users on CTAs, show the form immediately
			showCTAForm(container);
		} else {
			// For standalone page or account page, show immediately
			container.style.display = 'block';
		}

		if (debug) {
			console.log('SailThru: Template context requires login? ', requireLogin);
			console.log('SailThru: User actually logged in? ', isLoggedIn);
			console.log('SailThru: Is CTA? ', isCTA);
		}

		// Show/hide email input based on CONTEXT and actual login state
		const emailField = container.querySelector('[data-sailthru-email-field]');
		if (emailField) {
			const emailInput = emailField.querySelector('#subscribe-email');
			
			if (requireLogin) {
				// Account page - always hide email field (we know who they are)
				emailField.style.display = 'none';
				if (emailInput) {
					emailInput.required = false;
				}
			} else if (isCTA && isLoggedIn) {
				// CTA for logged-in user - hide email field (we know who they are)
				emailField.style.display = 'none';
				if (emailInput) {
					emailInput.required = false;
				}
			} else {
				// Public page or CTA for logged-out user - show email field
				emailField.style.display = 'block';
				if (emailInput) {
					emailInput.required = true;
				}
			}
		}

		// Update submit button text based on CONTEXT and login state
		const submitButton = form.querySelector('[data-sailthru-submit]');
		if (submitButton) {
			if (requireLogin) {
				// Account page
				submitButton.textContent = 'Update Preferences';
			} else if (isCTA && isLoggedIn) {
				// CTA for logged-in user
				submitButton.textContent = 'Subscribe';
			} else {
				// Public page or logged-out CTA
				submitButton.textContent = 'Sign Up';
			}
		}

		// Show opt-out ONLY on account pages (requireLogin=true)
		const optout = form.querySelector('[data-sailthru-optout]');
		if(optout) {
			if(requireLogin) {
				optout.style.display = 'block';
			} else {
				optout.style.display = 'none';
			}
		}

	// Store both context and actual login state
	form.dataset.sailthruRequireLogin = requireLogin;
	form.dataset.sailthruIsLoggedIn = isLoggedIn;

	if (debug) console.log('SailThru: Form initialized. Context: ' + (requireLogin ? 'account page' : 'public page'));
}

	/**
	 * Handle form submission
	 */
	function handleFormSubmit(e) {
		if (! e.target.matches('[data-sailthru-form]')) {
			return;
		}

		e.preventDefault();
		if (debug) console.log('SailThru: Form submitted.');

		const form = e.target;
		const requireLogin = form.dataset.sailthruRequireLogin === 'true';
		const isLoggedIn = form.dataset.sailthruIsLoggedIn === 'true';
		
		const container = form.closest('[data-sailthru-form-container]');
		const isCTA = container && (
			container.classList.contains('hc-newsletters-cta') || 
			container.classList.contains('hc-fancy-newsletter-signup')
		);

		if (debug) {
			console.log('SailThru: Form context requires login?', requireLogin);
			console.log('SailThru: User is logged in?', isLoggedIn);
			console.log('SailThru: Is CTA?', isCTA);
		}

		// Use different handler based on context and login state
		// Use logged-in handler for: account page OR logged-in user on CTA
		if (requireLogin || (isCTA && isLoggedIn)) {
			handleLoggedInSubmit(form);
		} else {
			handleLoggedOutSubmit(form);
		}
	}

	/**
	 * Handle logged-out user submission (original flow)
	 */
	function handleLoggedOutSubmit(form) {

		const container = form.closest('[data-sailthru-form-container]');
		const statusWrapper = container.querySelector('[data-sailthru-status]');
		const statusMessage = container.querySelector('[data-sailthru-message]');
		const button = form.querySelector('[data-sailthru-submit]');
		const submissionFields = form.querySelector('[data-sailthru-submission]');
		
		// Check if this is a CTA
		const isCTA = container && (
			container.classList.contains('hc-newsletters-cta') || 
			container.classList.contains('hc-fancy-newsletter-signup')
		);

		if (! button) {
			if (debug) console.error('SailThru: Submit button not found.');
			return;
		}

		const originalButtonText = button.textContent;

		// Disable button and show loading state
		button.disabled = true;
		button.textContent = 'Submitting... ';
		
		// Reset status messages
		if (statusWrapper) {
			statusWrapper.style.display = 'none';
			statusWrapper.classList.remove('subscribe-success', 'subscribe-error', 'login-status-success', 'login-status-error');
		}
		if (statusMessage) {
			statusMessage.textContent = '';
		}

		container.classList.remove('subscribe-success');

		// Prepare form data
		const formData = new FormData(form);
		/*! phpcs:disable WordPressVIPMinimum.JS.HTMLExecutingFunctions.append -- FormData.append() is for form submission, not DOM manipulation */
		formData.append('action', 'hc_newsletter_signup');
		formData.append('security', sailthruData.nonce);
		/*! phpcs:enable WordPressVIPMinimum.JS.HTMLExecutingFunctions.append */

		if (debug) {
			console.log('SailThru: Sending data:', Object.fromEntries(formData));
			console.log('SailThru: Lists:', formData.getAll('lists[]'));
		}

		// Submit to WordPress AJAX
		fetch(sailthruData.ajaxurl, {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			// Re-enable button
			button.disabled = false;
			button.textContent = originalButtonText;

		if (data.success) {
			// CTA-specific success handling
			if (isCTA) {
				const wrapper = container.querySelector('[data-sailthru-wrapper]');
				
				// Add success class to wrapper - CSS handles all show/hide/styling
				if (wrapper) {
					wrapper.classList.add('subscribe-success');
				}
			} else {
				// Non-CTA success handling (standalone page, etc.)
				if (statusMessage) {
					statusMessage.textContent = data.data.message || 'Thank you for subscribing! ';
				}
				if (statusWrapper) {
					statusWrapper.classList.add('subscribe-success', 'login-status-success');
					statusWrapper.classList.remove('subscribe-error', 'login-status-error');
					statusWrapper.style.display = 'inline-block';
				}

				if(submissionFields) {
					//hide submission fields
					submissionFields.style.display = 'none';
				}
			}

			container.classList.add('subscribe-success');
			
			// Clear email field; leave checkboxes reflecting the user's selections
			const emailField = form.querySelector('input[type="email"]');
			if (emailField) emailField.value = '';

			if (debug) console.log('SailThru: Subscription successful!');
			
		} else {
				// Show error message
				if (statusMessage) {
					statusMessage.textContent = data.data.message || 'An error occurred. Please try again.';
				}
				if (statusWrapper) {
					statusWrapper.classList.add('subscribe-error', 'login-status-error');
					statusWrapper.classList.remove('subscribe-success', 'login-status-success');
					statusWrapper.style.display = 'inline-block';
				}

				if(submissionFields) {
					//show submission fields
					submissionFields.style.display = 'flex';
				}
				
				if (debug) console.error('SailThru: Subscription failed:', data.data.message);
			}

		})
		.catch(error => {
			// Network/server error
			button.disabled = false;
			button.textContent = originalButtonText;

			if (statusMessage) {
				statusMessage.textContent = 'A server error occurred. Please try again.';
			}
			if (statusWrapper) {
				statusWrapper.classList.add('subscribe-error', 'login-status-error');
				statusWrapper.classList.remove('subscribe-success', 'login-status-success');
				statusWrapper.style.display = 'inline-block';
			}

			if(submissionFields) {
				//show submission fields
				submissionFields.style.display = 'flex';
			}

			if (debug) console.error('SailThru: Network error:', error);
		});
	}

	/**
	 * Handle logged-in user submission (update preferences)
	 */
	function handleLoggedInSubmit(form) {
		if (debug) console.log('SailThru: Handling logged-in user submission');

		const container = form.closest('[data-sailthru-form-container]');
		const statusWrapper = container.querySelector('[data-sailthru-status]');
		const statusMessage = container.querySelector('[data-sailthru-message]');
		const button = form.querySelector('[data-sailthru-submit]');

		if (!button) {
			if (debug) console.error('SailThru: Submit button not found.');
			return;
		}

		const originalButtonText = button.textContent;

		// Disable button and show loading state
		button.disabled = true;
		button.textContent = 'Updating...';

		// Reset status messages
		if (statusWrapper) {
			statusWrapper.style.display = 'none';
			statusWrapper.classList.remove('subscribe-success', 'subscribe-error', 'login-status-success', 'login-status-error');
		}
		if (statusMessage) {
			statusMessage.textContent = '';
		}

		// Prepare form data
		const formData = new FormData(form);
		/*! phpcs:disable WordPressVIPMinimum.JS.HTMLExecutingFunctions.append -- FormData.append() is for form submission, not DOM manipulation */
		formData.append('action', 'hc_update_email_preferences');
		formData.append('security', sailthruData.nonce);
		/*! phpcs:enable WordPressVIPMinimum.JS.HTMLExecutingFunctions.append */

		if (debug) {
			console.log('SailThru: Sending preferences update:', Object.fromEntries(formData));
			console.log('SailThru: Lists:', formData.getAll('lists[]'));
		}

		// Submit to WordPress AJAX
		fetch(sailthruData.ajaxurl, {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			// Re-enable button
			button.disabled = false;
			button.textContent = originalButtonText;

			if (data.success) {
				// Show success message
				if (statusMessage) {
					statusMessage.textContent = data.data.message || 'Your preferences have been updated!';
				}
				if (statusWrapper) {
					statusWrapper.classList.add('subscribe-success', 'login-status-success');
					statusWrapper.classList.remove('subscribe-error', 'login-status-error');
					statusWrapper.style.display = 'inline-block';
				}

				if (debug) console.log('SailThru: Preferences updated successfully!');
				
			} else {
				// Show error message
				if (statusMessage) {
					statusMessage.textContent = data.data.message || 'An error occurred. Please try again.';
				}
				if (statusWrapper) {
					statusWrapper.classList.add('subscribe-error', 'login-status-error');
					statusWrapper.classList.remove('subscribe-success', 'login-status-success');
					statusWrapper.style.display = 'inline-block';
				}

				if (debug) console.error('SailThru: Update failed:', data.data.message);
			}

		})
		.catch(error => {
			// Network/server error
			button.disabled = false;
			button.textContent = originalButtonText;

			if (statusMessage) {
				statusMessage.textContent = 'A server error occurred. Please try again.';
			}
			if (statusWrapper) {
				statusWrapper.classList.add('subscribe-error', 'login-status-error');
				statusWrapper.classList.remove('subscribe-success', 'login-status-success');
				statusWrapper.style.display = 'block';
			}

			if (debug) console.error('SailThru: Network error:', error);
		});
	}

	/**
	 * Handle "Unsubscribe from All" button click
	 */
	function handleUnsubscribeAll(e) {
		if (!e.target.matches('[data-sailthru-unsubscribe-all]')) {
			return;
		}

		e.preventDefault();

		if (!confirm('Are you sure you want to unsubscribe from all Commercial Observer emails?')) {
			return;
		}

		const button = e.target;
		const form = button.closest('[data-sailthru-form]');
		
		if (!form) {
			if (debug) console.error('SailThru: Form not found for unsubscribe button');
			return;
		}

		// Uncheck all checkboxes
		const checkboxes = form.querySelectorAll('input[type="checkbox"][name="lists[]"]');
		checkboxes.forEach(cb => cb.checked = false);

		// Submit the form
		form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
	}

	document.addEventListener('DOMContentLoaded', function () {
		// Initialize the form
		initSubscribeForm();

		// Listen for form submissions
		document.body.addEventListener('submit', handleFormSubmit);

		// Listen for unsubscribe all button
		document.body.addEventListener('click', handleUnsubscribeAll);
		
		if (debug) console.log('SailThru: Newsletter signup initialized.');
	});
})();
